import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useMemo, useState, useEffect } from 'react';
/**
 * useMediaMatch
 *
 * A react hook that signals whether or not a media query is matched.
 *
 * @param query The media query to signal on. Example, `"print"` will signal
 * `true` when previewing in print mode, and `false` otherwise.
 * @returns Whether or not the media query is currently matched.
 */

function useMediaMatch(query) {
  if (typeof window === 'undefined') {
    console.warn('useMediaMatch cannot function as window is undefined.');
    return false;
  }

  var matchMedia = useMemo(function () {
    return window.matchMedia(query);
  }, [query]);

  var _useState = useState(function () {
    return matchMedia.matches;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  useEffect(function () {
    setMatches(matchMedia.matches);

    var listener = function listener(ev) {
      return setMatches(ev.matches);
    };

    matchMedia.addEventListener('change', listener);
    return function () {
      return matchMedia.removeEventListener('change', listener);
    };
  }, [matchMedia]);
  return matches;
}

export default useMediaMatch;